import { Link } from "react-router-dom";
import { companyDetails } from "../constant";
import { ReactComponent as WhatsApp } from "../assets/svgs/WhatsappIcon.svg";

const WhatsAppIcon = () => {
  return (
    <Link
      className="hover:-translate-y-1 bg-white rounded-full transition-all duration-200"
      to={`https://wa.me/${companyDetails.phone}`}
      target="_blank"
      aria-label="Contact us on WhatsApp"
    >
      <WhatsApp className="w-[3.1rem] h-[3.1rem] fill-green-500 group-hover:fill-primary group-hover:scale-110 rounded-full shadow-transparent shadow-large group-hover:shadow-primary/50 transition-all duration-300" />
    </Link>
  );
};

export default WhatsAppIcon;
